import { LocalizedStringApiModel, StreamingPageItemApiModel, StreamingPageApiModel } from '@cxb/content-stb-api';
import { Entity } from '@nx-data/nx-data';

export class PageEntity extends Entity implements StreamingPageApiModel {
  public metaTags: { [p: string]: string };
  public pageItems: Array<StreamingPageItemApiModel>;
  public seoDescription: LocalizedStringApiModel;
  public seoTitle: LocalizedStringApiModel;
  public title: string;
  public titleLocalized: LocalizedStringApiModel;
}
